export const INTERCOM_ATTRIBUTE = 'data-intercom-target';
